export const ROLE = {
  VENTANERO: "ventanero",
  CALLCENTER: "callcenter",
  COORDINADOR: "coordinador",
  COORDINADOR_COS: "coordinador_cos",
  ADMIN: "admin",
  ROTACION: "rotacion"
};
